<template>
  <div :class="mode === 'add-licenses' ? 'white-background' : 'loginimg'">
    <!-- Only show logo for registration mode -->

    <CustomerLogo v-if="mode === 'registration'" />

    <div class="row justify-content-center">
      <div :class="mode === 'add-licenses' ? 'mt-6' : 'mt-10'" class="col-10 col-md-6 col-lg-5 col-xl-4 align-self-center justify-content-center row">

        <!-- Loading State -->
        <div v-if="isLoading" class="col-12 text-center">
          <v-progress-circular
            indeterminate
            :color="mode === 'add-licenses' ? 'black' : 'white'"
            size="64"
            width="6"
            class="mb-6">
          </v-progress-circular>
          <div :class="mode === 'add-licenses' ? 'black--text' : 'white--text'" class="mb-2" style="font-size: 18px; font-weight: 500;">
            {{ $t('verifying_payment') }}
          </div>
          <div :class="mode === 'add-licenses' ? 'black--text' : 'white--text'" style="opacity: 0.7; font-size: 14px;">
            {{ $t('please_wait') }}...
          </div>
        </div>

        <!-- Success State -->
        <div v-else-if="success" class="col-12 text-center">
          <v-icon :color="mode === 'add-licenses' ? '#4CAF50' : 'white'" size="80" class="mb-6">
            mdi-check-circle
          </v-icon>
          <div :class="mode === 'add-licenses' ? 'black--text' : 'white--text'" class="text-h4 mb-4">
            {{ $t('payment_successful') }}
          </div>
          <div :class="mode === 'add-licenses' ? 'black--text' : 'white--text'" class="col-10 mx-auto mb-6" style="opacity: 0.85; font-size: 16px;">
            {{ $t('subscription_activated_message') }}
          </div>
          <div :class="mode === 'add-licenses' ? 'black--text' : 'white--text'" class="mb-2" style="opacity: 0.7; font-size: 14px;">
            {{ $t('redirecting_automatically') }}
          </div>
          <v-progress-linear
            :color="mode === 'add-licenses' ? 'black' : 'white'"
            :value="redirectProgress"
            class="mt-4 col-10 mx-auto"
            height="2">
          </v-progress-linear>
        </div>

        <!-- Error State -->
        <div v-else-if="error" class="col-12 text-center">
          <v-icon color="#ff6363" size="80" class="mb-6">
            mdi-alert-circle
          </v-icon>
          <div :class="mode === 'add-licenses' ? 'black--text' : 'white--text'" class="text-h4 mb-4">
            {{ $t('payment_failed') }}
          </div>
          <div :class="mode === 'add-licenses' ? 'black--text' : 'white--text'" class="col-10 mx-auto mb-8" style="opacity: 0.85; font-size: 16px;">
            {{ errorMessage }}
          </div>

          <div class="col-10 mx-auto">
            <v-btn
              class="signinbtn white--text w-100"
              style="padding: 27px !important; background-color: #161616 !important;"
              outlined
              tile
              @click="tryAgain">
              {{ $t('try_again') }}
            </v-btn>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import CustomerLogo from "@/components/custom/CustomerLogo.vue";

export default {
  name: 'SubscriptionSuccess',
  components: {CustomerLogo},

  data() {
    return {
      isLoading: true,
      success: false,
      error: false,
      errorMessage: '',
      redirectProgress: 0,
      redirectTimer: null
    };
  },

  computed: {
    sessionId() {
      return this.$route.query.session_id;
    },

    mode() {
      return this.$route.query.mode || 'registration';
    }
  },

  mounted() {
    this.verifyPayment();
  },

  beforeDestroy() {
    if (this.redirectTimer) {
      clearInterval(this.redirectTimer);
    }
  },

  methods: {
    verifyPayment() {
      // Validate session ID exists
      if (!this.sessionId) {
        this.isLoading = false;
        this.error = true;
        this.errorMessage = this.$t('invalid_payment_session');
        return;
      }

      this.isLoading = true;

      this.$axios.get(`api/payment/check-payment-status/session/${this.sessionId}`)
        .then(() => {
          this.success = true;
          this.isLoading = false;
          this.startRedirectTimer();
        })
        .catch(error => {
          console.error('Payment verification error:', error);
          this.error = true;
          this.isLoading = false;
          this.errorMessage = this.$t('payment_verification_failed');
        });
    },

    startRedirectTimer() {
      const duration = 3000; // 3 seconds
      const interval = 50; // Update every 50ms
      const steps = duration / interval;
      let currentStep = 0;

      this.redirectTimer = setInterval(() => {
        currentStep++;
        this.redirectProgress = (currentStep / steps) * 100;

        if (currentStep >= steps) {
          clearInterval(this.redirectTimer);
          this.redirect();
        }
      }, interval);
    },

    redirect() {
      if (this.mode === 'registration') {
        // For new registrations, redirect to login
        this.$router.push('/login');
      } else {
        // For adding licenses, redirect back to licenses page
        this.$router.push('/licenses');
      }
    },

    tryAgain() {
      this.$router.push({
        path: '/subscription-plans',
        query: { mode: this.mode }
      });
    }
  }
};
</script>

<style scoped>
.white-background {
  background-color: white;
  min-height: 100vh;
  padding: 20px 0;
}

.v-progress-circular {
  margin: 0 auto;
}
</style>
